export const DRAWER_VIEW_ASSISTANT = 'assistant';
export const DRAWER_VIEW_FILTERS = 'filters';

// Panel widths — structural measurements from the spec (Feature 7, FR-7.4), not spacing tokens.
export const PANEL_WIDTH_DEFAULT = 372;
export const PANEL_WIDTH_FOCUSED = 460;
export const RESULTS_FILTERS_RAIL_WIDTH = 84;
